import React from 'react'
import theme from '../config/theme'

interface TableProps {
  data: any[]
  className?: string
  renderRow?: (item: any) => React.ReactNode
  header?: string[]
  headerAlignments?: ('left' | 'right' | 'center')[]
}

const Table: React.FC<TableProps> = ({
  data,
  className = '',
  renderRow,
  header = [],
  headerAlignments = []
}) => {
  return (
    <div 
      className={`bg-white rounded-lg shadow-sm ${className}`} 
      style={{ 
        border: `1px solid ${theme.color.light300}`, 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        overflow: 'hidden'
      }}
    >
      <div 
        style={{ 
          overflowY: 'auto', 
          overflowX: 'auto', 
          flex: 1, 
          minHeight: 0,
          position: 'relative'
        }}
      >
        <table className="w-full border-collapse">
          <thead 
            style={{ 
              position: 'sticky', 
              top: 0, 
              zIndex: 10, 
              backgroundColor: theme.color.light100 
            }}
          >
            <tr style={{ borderBottom: `1px solid ${theme.color.light300}` }}>
            {header.map((item, index) => {
              const alignment = headerAlignments[index] || 'left'
              const alignmentClass = alignment === 'right' ? 'text-right' : alignment === 'center' ? 'text-center' : 'text-left'
              return (
                <th
                  key={index}
                  className={`px-6 py-3 ${alignmentClass} text-md tracking-wider font-medium`}
                  style={{ 
                    color: theme.color.light,
                    backgroundColor: theme.color.light100,
                    position: 'sticky',
                    top: 0,
                    zIndex: 10
                  }}
                >
                  {item}
                </th>
              )
            })}
            </tr>
          </thead>
          <tbody
            style={{
              backgroundColor: theme.color.light100,
              borderColor: theme.color.light300
            }}
          >
            {data.map((item) => (
              <tr key={item.id} className="hover:bg-gray-50 transition-colors" style={{ borderBottom: `1px solid ${theme.color.light300}` }}>
                {renderRow?.(item)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Table
